import ReactDOM from "react-dom/client";
import "./index.css";
import { ChakraProvider, extendTheme } from "@chakra-ui/react";
import App from "./App";
import { AppConfigProvider } from "AppConfigProvider";
import initializeI18n from "./i18nInit";
import "react-vertical-timeline-component/style.min.css";
import "react-quill/dist/quill.snow.css";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

import TagManager from 'react-gtm-module';
 
const tagManagerArgs = {
    gtmId: 'GTM-WPN2VBML',
    dataLayer: {
      server_container_url: 'https://gtm.qcall.ai'
    }
}

const theme = extendTheme({
  config: {
    initialColorMode: "light",
    useSystemColorMode: false, // prevents following OS dark mode
  },
});

TagManager.initialize(tagManagerArgs)

// Initialize i18n
initializeI18n();

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
    <ChakraProvider theme={theme}>
      <AppConfigProvider>
        <App />
      </AppConfigProvider>
    </ChakraProvider>
);
